// ###不要动此文件，路由配置在各自活动目录下修改###
import router, { store } from 'dynamic-import-router.js';
export default router;
export { store };
